var _circle, _circle2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 141,
    viewBox: "0 0 141 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 70.5,
    r: 70.5,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 70.5,
    r: 63.5,
    fill: "#7E42FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.8831 43.0503C44.1958 41.7375 45.9763 41 47.8328 41H105.172C106.953 41 107.846 43.1543 106.586 44.4142L97.1169 53.8831C95.8042 55.1958 94.0237 55.9333 92.1672 55.9333H34.8284C33.0466 55.9333 32.1543 53.7791 33.4142 52.5191L42.8831 43.0503Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8831 88.3836C44.1958 87.0709 45.9763 86.3334 47.8328 86.3334H105.172C106.953 86.3334 107.846 88.4877 106.586 89.7476L97.1169 99.2165C95.8042 100.529 94.0237 101.267 92.1672 101.267H34.8284C33.0466 101.267 32.1543 99.1124 33.4142 97.8525L42.8831 88.3836Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8831 76.2831C44.1958 77.5959 45.9763 78.3334 47.8328 78.3334H105.172C106.953 78.3334 107.846 76.1791 106.586 74.9192L97.1169 65.4503C95.8042 64.1375 94.0237 63.4 92.1672 63.4H34.8284C33.0466 63.4 32.1543 65.5543 33.4142 66.8143L42.8831 76.2831Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar1);
export default __webpack_public_path__ + "static/media/avatar1.4dd280f5d709430319c5c96990a8f9c6.svg";
export { ForwardRef as ReactComponent };